import { Divider as AntdDivider } from "antd"

const Divider = props => {
  return <AntdDivider {...props} />
}

export default Divider
